import type { JSX } from 'react'

export const ChatSolidIcon = (): JSX.Element => (
  <use href='#chatSolidIcon' height='100%' width='100%' />
)
